import { paths } from 'src/routes/paths';

import axios from 'src/utils/axios';

import {
  STORAGE_KEY,
  TAIRRA_STORAGE_KEY,
  EMPLOYEE_ID_KEY,
  IS_ADMIN_KEY,
  IS_EMAIL_VERIFIED_KEY,
  ROLE_KEY,
  EXPIRATION_KEY,
  CLIENT_ID_KEY,
  USER_RIIGHT_PERMISSIN,
} from './constants';
import { log } from '@utils/console-logger';

// ----------------------------------------------------------------------

export function jwtDecode(token) {
  try {
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length < 2) {
      throw new Error('Invalid token!');
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));

    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken) {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);

    if (!decoded || !('exp' in decoded)) {
      return false;
    }

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Error during token validation:', error);
    return false;
  }
}

// ----------------------------------------------------------------------

export function tokenExpired(exp) {
  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;

  setTimeout(() => {
    try {
      alert('Token expired!');
      localStorage.removeItem(STORAGE_KEY);

      window.location.href = paths.auth.jwt.signIn;
    } catch (error) {
      console.error('Error during token expiration:', error);
      throw error;
    }
  }, timeLeft);
}

// ----------------------------------------------------------------------

export async function setSession(accessToken) {
  try {
    if (accessToken) {
      localStorage.setItem(STORAGE_KEY, accessToken);

      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

      const decodedToken = jwtDecode(accessToken); // ~3 days by minimals server

      if (decodedToken && 'exp' in decodedToken) {
        tokenExpired(decodedToken.exp);
      } else {
        throw new Error('Invalid access token!');
      }
    } else {
      localStorage.removeItem(STORAGE_KEY);
      delete axios.defaults.headers.common.Authorization;
    }
  } catch (error) {
    console.error('Error during set session:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export async function setTairraApiSession(accessToken) {
  try {
    if (accessToken) {
      localStorage.setItem(TAIRRA_STORAGE_KEY, accessToken);
      const decodedToken = jwtDecode(accessToken);

      if (decodedToken && 'exp' in decodedToken) {
        localStorage.setItem(EMPLOYEE_ID_KEY, decodedToken.employeeId || '');
        localStorage.setItem(IS_ADMIN_KEY, decodedToken.isAdmin || false);
        localStorage.setItem(IS_EMAIL_VERIFIED_KEY, decodedToken.isEmailVerified || false);
        localStorage.setItem(USER_RIIGHT_PERMISSIN, decodedToken.userRightPermission || {});
        localStorage.setItem(ROLE_KEY, decodedToken.role || '');
        localStorage.setItem(EXPIRATION_KEY, decodedToken.exp || '');
        localStorage.setItem(CLIENT_ID_KEY, decodedToken.client_id || '');
        tokenExpired(decodedToken.exp);
      } else {
        throw new Error('Invalid access token!');
      }
    } else {
      localStorage.removeItem(TAIRRA_STORAGE_KEY);
      localStorage.removeItem(TAIRRA_STORAGE_KEY);
      localStorage.removeItem(EMPLOYEE_ID_KEY);
      localStorage.removeItem(IS_ADMIN_KEY);
      localStorage.removeItem(IS_EMAIL_VERIFIED_KEY);
      localStorage.removeItem(ROLE_KEY);
      localStorage.removeItem(EXPIRATION_KEY);
    }
  } catch (error) {
    console.error('Error during set session:', error);
    throw error;
  }
}
